import { render } from "./AnimatedRouterView.vue?vue&type=template&id=be9eae82&scoped=true"
import script from "./AnimatedRouterView.vue?vue&type=script&lang=js"
export * from "./AnimatedRouterView.vue?vue&type=script&lang=js"

import "./AnimatedRouterView.vue?vue&type=style&index=0&id=be9eae82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9eae82"]])

export default __exports__